module.exports = __webpack_public_path__ + "img/Logo_svg.3d601758.svg";